/* ============================================================================
   KD ENHANCE  ·  mejoras de conversión sin dependencias pesadas
   - "Agregar al carrito" rápido desde las tarjetas (solo 1 variante).
   - Se integra con el drawer AJAX existente (ajaxifyShopify) si está activo.
   - Si algo falla, hace fallback a la página de producto. Nunca rompe el flujo.
   ============================================================================ */
(function () {
  "use strict";

  function formatMoney(cents, fmt) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, fmt);
    } catch (e) {}
    return "$" + (cents / 100).toFixed(2);
  }

  function refreshCartUI(cart) {
    var count = cart && typeof cart.item_count === "number" ? cart.item_count : null;
    if (count === null) return;
    document.querySelectorAll("#cartCount, .cart-count").forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("hidden-count", count === 0);
    });
  }

  // Intenta abrir/recargar el drawer AJAX del tema (Timber ajaxify).
  function syncDrawer() {
    try {
      if (window.ajaxifyShopify && typeof ajaxifyShopify.init === "function") {
        // ajaxify se reinicializa solo al detectar cambios; forzamos toggle visible.
        var toggle = document.getElementById("cartToggle");
        if (toggle) toggle.click();
      }
    } catch (e) {}
  }

  function quickAdd(btn) {
    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) {
      window.location.href = btn.getAttribute("data-product-url") || "/cart";
      return;
    }
    var original = btn.innerHTML;
    btn.setAttribute("disabled", "disabled");
    btn.innerHTML = btn.getAttribute("data-adding") || "Agregando…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        refreshCartUI(cart);
        btn.innerHTML = btn.getAttribute("data-added") || "✓ Agregado";
        syncDrawer();
        setTimeout(function () {
          btn.innerHTML = original;
          btn.removeAttribute("disabled");
        }, 1800);
      })
      .catch(function () {
        // fallback seguro: ir a la página del producto
        window.location.href = btn.getAttribute("data-product-url") || "/cart";
      });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest(".kd-quick-add") : null;
    if (!btn) return;
    e.preventDefault();
    quickAdd(btn);
  });
})();
